import { User } from '~/models';

export class UserCurrent extends User {
  static override entity = 'orm/auth/users';
}
